/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles, MuiThemeProvider } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';
import { universalStyles, poslumaDarkBlue, poslumaTheme } from '../../../../app/theme';
import { BASE_URL, IMAGE_PATHS } from '../../../../constants/paths.constants';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  headerImage: {
    display: 'block',
    width: '100%',
  },
  heading: {
    paddingTop: 30,
  },
  flex: {
    display: 'flex',
    marginTop: 50,
  },
  col: {
    flex: 1,
    padding: '50px 2.5% 0 2.5%',
    marginLeft: -1,
    border: `1px solid ${poslumaDarkBlue}`,
  },
  checkmark: {
    width: '15%',
    marginLeft: '42%',
    marginTop: -35,
    paddingBottom: 10,
  },
  superscript: {
    fontSize: 11,
  },
}));

const AcquisitionPage05 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <MuiThemeProvider theme={poslumaTheme}>
      <div className={classes.poslumaBox}>
        <img
          className={classes.headerImage}
          src={`${BASE_URL}${IMAGE_PATHS.STEPS[2].ACQUISITION_STEP_1.path}`}
          alt={`${IMAGE_PATHS.STEPS[2].ACQUISITION_STEP_1.alt}`}
        />
        <div className={classes.whiteBox}>
          <Typography variant="h2">STEP 1:</Typography>
          <Typography variant="h3">Instrumentation for Use with POSLUMA</Typography>
          <Typography className={classes.heading} variant="h4">
            POSLUMA PET Instrumentation
          </Typography>
          <ul className={classes.poslumaList}>
            <Typography>
              <li>
                Adapt imaging technique according to the equipment used to obtain the best image quality possible.
                <sup className={classes.superscript}>1</sup>
              </li>
            </Typography>
          </ul>
          <div className={classes.flex}>
            <div className={classes.col}>
              <img
                className={classNames(classes.checkmark)}
                src={`${BASE_URL}${IMAGE_PATHS.YES_CHECK.path}`}
                alt={`${IMAGE_PATHS.YES_CHECK.alt}`}
              />
              <Typography variant="body1">
                <b>The suggested minimum criteria for suitable PET systems are as follows</b>
                <sup className={classes.superscript}>2</sup>:
              </Typography>
              <ul className={classes.poslumaList}>
                <li>
                  Quality control and calibration, including for radionuclide dose calibrators and patient weighing
                  scales, performed per manufacturer recommendations
                </li>
                <li>Typical scanner corrections—decay, scatter, and attenuation</li>
                <li>Iterative image reconstruction</li>
                <li>Time of flight correction</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </MuiThemeProvider>
  );
};

export default AcquisitionPage05;
